/* Author : Nitish Hardeniya */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Signup from '../components/signup';
import * as authActions from '../actions/authActions';

function mapStateToProps(state) {
  return {
    auth: state.auth,
    countryCodes: state.countryCodes,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...authActions,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Signup);
